import { GetInterestListsPublicQuery, useGetInterestListsPublicQuery } from "../../generated/graphql"

export type InterestListItem = GetInterestListsPublicQuery["interestListsPublic"][0]

/**
 * Gemeinsame Auflösung einer öffentlichen Interessenten-Liste anhand der URL-ID.
 * Das Backend bietet aktuell nur die Listen-Abfrage an; Apollo hält das Ergebnis
 * zwischen Detailseite und Anmeldung im Cache.
 */
export function useInterestListById(id?: string) {
    const query = useGetInterestListsPublicQuery({ fetchPolicy: "cache-and-network" })
    const list = query.data?.interestListsPublic.find((entry) => entry.id === id)

    return {
        ...query,
        list,
        notFound: Boolean(query.data) && !query.loading && !list,
    }
}
